import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-38435638"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "m-matchCard"
};
const _hoisted_2 = {
  class: "m-matchCard-Cen"
};
const _hoisted_3 = {
  class: "u-top"
};
const _hoisted_4 = {
  class: "u-middle"
};
const _hoisted_5 = {
  class: "u-middleLf"
};
const _hoisted_6 = {
  class: "u-middleMid"
};
const _hoisted_7 = {
  class: "num"
};
const _hoisted_8 = {
  class: "colon"
};
const _hoisted_9 = {
  class: "num"
};
const _hoisted_10 = {
  class: "u-middleRt"
};
const _hoisted_11 = {
  class: "u-btm"
};
const _hoisted_12 = {
  class: "m-box"
};
const _hoisted_13 = {
  class: "u-detail"
};
const _hoisted_14 = {
  class: "u-detail"
};
const _hoisted_15 = {
  class: "m-title"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("em", null, null, -1));
const _hoisted_17 = {
  class: "m-titleRt"
};
const _hoisted_18 = {
  class: "m-checkList",
  style: {
    "opacity": "1"
  }
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "全部赛制", -1));
const _hoisted_20 = [_hoisted_19];
const _hoisted_21 = {
  class: "m-checkList",
  style: {
    "opacity": "1"
  }
};
const _hoisted_22 = {
  class: "m-titleRt"
};
const _hoisted_23 = {
  class: "m-checkList",
  style: {
    "opacity": "1",
    "margin-left": "280px"
  }
};
const _hoisted_24 = {
  class: "m-tableBox"
};
const _hoisted_25 = {
  class: "m-tableTitle"
};
const _hoisted_26 = {
  class: "u-tit"
};
const _hoisted_27 = {
  class: "u-team"
};
const _hoisted_28 = {
  class: "u-red"
};
const _hoisted_29 = {
  class: "u-green"
};
const _hoisted_30 = {
  class: "u-blue"
};
const _hoisted_31 = {
  class: "m-tableData"
};
const _hoisted_32 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [/*#__PURE__*/_createElementVNode("th", {
  width: "110"
}, "比赛日期"), /*#__PURE__*/_createElementVNode("th", {
  width: "108"
}, "赛制"), /*#__PURE__*/_createElementVNode("th", {
  width: "300"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "m-tableFlex"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "left1"
}, "主队"), /*#__PURE__*/_createElementVNode("div", {
  class: "center1"
}, "VS"), /*#__PURE__*/_createElementVNode("div", {
  class: "right1"
}, "客队")])])], -1));
const _hoisted_33 = {
  class: "u-date"
};
const _hoisted_34 = {
  class: "u-team"
};
const _hoisted_35 = {
  class: "m-tableFlex"
};
const _hoisted_36 = {
  class: "left1 hoverClass"
};
const _hoisted_37 = {
  class: "center1"
};
const _hoisted_38 = {
  class: "u-top"
};
const _hoisted_39 = {
  class: "u-btm hoverClass"
};
const _hoisted_40 = {
  class: "right1 hoverClass"
};
const _hoisted_41 = {
  class: "m-title"
};
const _hoisted_42 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("em", null, null, -1));
const _hoisted_43 = {
  class: "m-titleRt"
};
const _hoisted_44 = {
  class: "m-checkList",
  style: {
    "opacity": "1"
  }
};
const _hoisted_45 = {
  class: "m-checkList",
  style: {
    "opacity": "1"
  }
};
const _hoisted_46 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "全部赛制", -1));
const _hoisted_47 = [_hoisted_46];
const _hoisted_48 = {
  class: "m-titleRt"
};
const _hoisted_49 = {
  class: "m-checkList",
  style: {
    "opacity": "1"
  }
};
const _hoisted_50 = {
  class: "m-checkList",
  style: {
    "opacity": "1"
  }
};
const _hoisted_51 = {
  class: "m-tableBox"
};
const _hoisted_52 = {
  class: "m-tableTitle"
};
const _hoisted_53 = {
  class: "u-tit"
};
const _hoisted_54 = {
  class: "u-team"
};
const _hoisted_55 = {
  class: "u-red"
};
const _hoisted_56 = {
  class: "u-green"
};
const _hoisted_57 = {
  class: "u-blue"
};
const _hoisted_58 = {
  class: "m-tableData"
};
const _hoisted_59 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [/*#__PURE__*/_createElementVNode("th", {
  width: "110"
}, "比赛日期"), /*#__PURE__*/_createElementVNode("th", {
  width: "108"
}, "赛制"), /*#__PURE__*/_createElementVNode("th", {
  width: "300"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "m-tableFlex"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "left1"
}, "主队"), /*#__PURE__*/_createElementVNode("div", {
  class: "center1"
}, "VS"), /*#__PURE__*/_createElementVNode("div", {
  class: "right1"
}, "客队")])])], -1));
const _hoisted_60 = {
  class: "u-date"
};
const _hoisted_61 = {
  class: "u-team"
};
const _hoisted_62 = {
  class: "m-tableFlex"
};
const _hoisted_63 = {
  class: "left1 hoverClass"
};
const _hoisted_64 = {
  class: "center1"
};
const _hoisted_65 = {
  class: "u-top"
};
const _hoisted_66 = {
  class: "u-btm hoverClass"
};
const _hoisted_67 = {
  class: "right1 hoverClass"
};
import { onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import axios from 'axios';
export default {
  __name: 'MatchInfo',
  setup(__props) {
    const route = useRoute();
    onMounted(() => {
      getMatchHeadV1();
      getResultHistoryV1(termLimits.value, tournamentFlag.value, homeAwayFlag.value);
      getMatchResultV1(termLimits2.value, tournamentFlag2.value, homeAwayFlag2.value);
    });
    const termLimits = ref(10);
    const tournamentFlag = ref(0);
    const homeAwayFlag = ref(0);
    const termLimits2 = ref(10);
    const tournamentFlag2 = ref(0);
    const homeAwayFlag2 = ref(0);
    const team = ref(0);
    const clickDiv = (obj, event) => {
      if (obj.isActive == 1) {
        isActive1.value = true;
        isActive2.value = false;
        tournamentFlag.value = 0;
      } else if (obj.isActive == 2) {
        isActive1.value = false;
        isActive2.value = true;
        tournamentFlag.value = 1;
      }
      if (obj.isActive == 3) {
        isActive3.value = true;
        isActive4.value = false;
        homeAwayFlag.value = 0;
      } else if (obj.isActive == 4) {
        isActive3.value = false;
        isActive4.value = true;
        homeAwayFlag.value = 1;
      }
      if (obj.isActive == 5) {
        isActive5.value = true;
        isActive6.value = false;
        termLimits.value = 10;
      } else if (obj.isActive == 6) {
        isActive5.value = false;
        isActive6.value = true;
        termLimits.value = 20;
      }
      getResultHistoryV1(termLimits.value, tournamentFlag.value, homeAwayFlag.value);
      //console.log('被点击的元素:', event.target);
      //console.log('自定义数据对象:', obj);
    };
    const clickDiv3 = (obj, event) => {
      if (obj.isActive == 7) {
        isActive7.value = true;
        isActive8.value = false;
        team.value = 0;
      } else if (obj.isActive == 8) {
        isActive7.value = false;
        isActive8.value = true;
        team.value = 1;
      }
      if (team.value == 0) {
        teamMatchList.value = matchResult.value.home.matchList;
        teamStatistics.value = matchResult.value.home.statistics;
      } else {
        teamMatchList.value = matchResult.value.away.matchList;
        teamStatistics.value = matchResult.value.away.statistics;
      }
    };
    const clickDiv2 = (obj, event) => {
      if (obj.isActive == 9) {
        isActive9.value = true;
        isActive10.value = false;
        tournamentFlag2.value = 0;
      } else if (obj.isActive == 10) {
        isActive9.value = false;
        isActive10.value = true;
        tournamentFlag2.value = 1;
      }
      if (obj.isActive == 11) {
        isActive11.value = true;
        isActive12.value = false;
        homeAwayFlag2.value = 0;
      } else if (obj.isActive == 12) {
        isActive11.value = false;
        isActive12.value = true;
        homeAwayFlag2.value = 1;
      }
      if (obj.isActive == 13) {
        isActive13.value = true;
        isActive14.value = false;
        termLimits2.value = 10;
      } else if (obj.isActive == 14) {
        isActive13.value = false;
        isActive14.value = true;
        termLimits2.value = 20;
      }
      getMatchResultV1(termLimits2.value, tournamentFlag2.value, homeAwayFlag2.value);

      //console.log('被点击的元素:', event.target);
      //console.log('自定义数据对象:', obj);
    };
    const isActive1 = ref(true);
    const isActive2 = ref(false);
    const isActive3 = ref(true);
    const isActive4 = ref(false);
    const isActive5 = ref(true);
    const isActive6 = ref(false);
    const isActive7 = ref(true);
    const isActive8 = ref(false);
    const isActive9 = ref(true);
    const isActive10 = ref(false);
    const isActive11 = ref(true);
    const isActive12 = ref(false);
    const isActive13 = ref(true);
    const isActive14 = ref(false);
    const matchId = route.params.matchId;
    const matchHead = ref({});
    const homeGoal = ref('');
    const awayGoal = ref('');
    const colon = ref('');
    const wbsjStatsHome = ref({});
    const wbsjStatsAway = ref({});
    const historyMatchList = ref([]);
    const historyStatistics = ref({});
    const teamMatchList = ref([]);
    const teamStatistics = ref({});
    const matchResult = ref({});
    const getMatchHeadV1 = async () => {
      const response = await axios.get('https://webapi.sporttery.cn/gateway/uniform/football/getMatchHeadV1.qry?source=web&sportteryMatchId=' + matchId);
      let data = response.data;
      matchHead.value = data.value;
      let fullCourtGoal = data.value.fullCourtGoal;
      wbsjStatsHome.value = data.value.wbsjStats.home;
      wbsjStatsAway.value = data.value.wbsjStats.away;
      if (fullCourtGoal != '') {
        homeGoal.value = fullCourtGoal.split(":")[0];
        awayGoal.value = fullCourtGoal.split(":")[1];
        colon.value = ':';
      }
    };
    const getMatchResultV1 = async (termLimits, tournamentFlag, homeAwayFlag) => {
      const response = await axios.get('https://webapi.sporttery.cn/gateway/uniform/football/getMatchResultV1.qry?sportteryMatchId=' + matchId + '&termLimits=' + termLimits + '&tournamentFlag=' + tournamentFlag + '&homeAwayFlag=' + homeAwayFlag);
      let data = response.data;
      matchResult.value = data.value;
      if (team.value == 0) {
        teamMatchList.value = data.value.home.matchList;
        teamStatistics.value = data.value.home.statistics;
      } else {
        teamMatchList.value = data.value.away.matchList;
        teamStatistics.value = data.value.away.statistics;
      }
    };
    const getResultHistoryV1 = async (termLimits, tournamentFlag, homeAwayFlag) => {
      const response = await axios.get('https://webapi.sporttery.cn/gateway/uniform/football/getResultHistoryV1.qry?sportteryMatchId=' + matchId + '&termLimits=' + termLimits + '&tournamentFlag=' + tournamentFlag + '&homeAwayFlag=' + homeAwayFlag);
      let data = response.data;
      historyMatchList.value = data.value.matchList;
      historyStatistics.value = data.value.statistics;
    };
    return (_ctx, _cache) => {
      const _component_nut_col = _resolveComponent("nut-col");
      const _component_nut_row = _resolveComponent("nut-row");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_nut_row, null, {
        default: _withCtx(() => [_createVNode(_component_nut_col, {
          span: 24
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(matchHead.value.matchNum) + " " + _toDisplayString(matchHead.value.tournamentCnShortName), 1), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString(matchHead.value.homeTeamShortName), 1), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, _toDisplayString(homeGoal.value), 1), _createElementVNode("div", _hoisted_8, _toDisplayString(colon.value), 1), _createElementVNode("div", _hoisted_9, _toDisplayString(awayGoal.value), 1)]), _createElementVNode("div", _hoisted_10, _toDisplayString(matchHead.value.awayTeamShortName), 1)]), _createElementVNode("div", _hoisted_11, [_createTextVNode(_toDisplayString(matchHead.value.seasonName) + " " + _toDisplayString(matchHead.value.phaseName) + " ", 1), matchHead.value.gameweek != '' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_createTextVNode(" 第" + _toDisplayString(matchHead.value.gameweek) + "轮", 1)], 64)) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString(matchHead.value.matchDateTime), 1)])])])]),
          _: 1
        })]),
        _: 1
      }), _createElementVNode("div", _hoisted_12, [_createVNode(_component_nut_row, null, {
        default: _withCtx(() => [_createVNode(_component_nut_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_13, [_createElementVNode("p", null, [_createTextVNode("排名: 常规赛 第"), _createElementVNode("span", null, _toDisplayString(wbsjStatsHome.value.ranking), 1), _createTextVNode("名 ")]), _createElementVNode("p", null, [_createTextVNode("赛季总成绩: "), _createElementVNode("span", null, _toDisplayString(wbsjStatsHome.value.sWinGoalMatchCnt), 1), _createTextVNode("胜 "), _createElementVNode("span", null, _toDisplayString(wbsjStatsHome.value.sDrawMatchCnt), 1), _createTextVNode("平 "), _createElementVNode("span", null, _toDisplayString(wbsjStatsHome.value.sLossGoalMatchCnt), 1), _createTextVNode("负")]), _createElementVNode("p", null, [_createTextVNode("赛季主场成绩: "), _createElementVNode("span", null, _toDisplayString(wbsjStatsHome.value.sHomeWinGoalMatchCnt), 1), _createTextVNode("胜 "), _createElementVNode("span", null, _toDisplayString(wbsjStatsHome.value.sHomeDrawMatchCnt), 1), _createTextVNode("平 "), _createElementVNode("span", null, _toDisplayString(wbsjStatsHome.value.sHomeLossGoalMatchCnt), 1), _createTextVNode("负")])])]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_14, [_createElementVNode("p", null, [_createTextVNode("排名: 常规赛 第"), _createElementVNode("span", null, _toDisplayString(wbsjStatsAway.value.ranking), 1), _createTextVNode("名 ")]), _createElementVNode("p", null, [_createTextVNode("赛季总成绩: "), _createElementVNode("span", null, _toDisplayString(wbsjStatsAway.value.sWinGoalMatchCnt), 1), _createTextVNode("胜 "), _createElementVNode("span", null, _toDisplayString(wbsjStatsAway.value.sDrawMatchCnt), 1), _createTextVNode("平 "), _createElementVNode("span", null, _toDisplayString(wbsjStatsAway.value.sLossGoalMatchCnt), 1), _createTextVNode("负")]), _createElementVNode("p", null, [_createTextVNode("赛季客场成绩: "), _createElementVNode("span", null, _toDisplayString(wbsjStatsAway.value.sHomeWinGoalMatchCnt), 1), _createTextVNode("胜 "), _createElementVNode("span", null, _toDisplayString(wbsjStatsAway.value.sHomeDrawMatchCnt), 1), _createTextVNode("平 "), _createElementVNode("span", null, _toDisplayString(wbsjStatsAway.value.sHomeLossGoalMatchCnt), 1), _createTextVNode("负")])])]),
          _: 1
        })]),
        _: 1
      })]), _createElementVNode("div", _hoisted_15, [_hoisted_16, _createTextVNode("历史交锋 "), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createElementVNode("div", {
        class: _normalizeClass(["u-check", {
          active: isActive1.value
        }]),
        onClick: _cache[0] || (_cache[0] = $event => clickDiv({
          flag: 0,
          isActive: 1
        }, $event))
      }, _hoisted_20, 2), _createElementVNode("div", {
        class: _normalizeClass(["u-check", {
          active: isActive2.value
        }]),
        onClick: _cache[1] || (_cache[1] = $event => clickDiv({
          flag: 1,
          isActive: 2
        }, $event))
      }, "相同赛制", 2)]), _createElementVNode("div", _hoisted_21, [_createElementVNode("div", {
        class: _normalizeClass(["u-check", {
          active: isActive3.value
        }]),
        onClick: _cache[2] || (_cache[2] = $event => clickDiv({
          flag: 0,
          isActive: 3
        }, $event))
      }, "不区分主客场", 2), _createElementVNode("div", {
        class: _normalizeClass(["u-check", {
          active: isActive4.value
        }]),
        onClick: _cache[3] || (_cache[3] = $event => clickDiv({
          flag: 1,
          isActive: 4
        }, $event))
      }, "相同主客场", 2)])]), _createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_createElementVNode("div", {
        class: _normalizeClass(["u-check", {
          active: isActive5.value
        }]),
        onClick: _cache[4] || (_cache[4] = $event => clickDiv({
          flag: 0,
          isActive: 5
        }, $event))
      }, "近10场", 2), _createElementVNode("div", {
        class: _normalizeClass(["u-check", {
          active: isActive6.value
        }]),
        onClick: _cache[5] || (_cache[5] = $event => clickDiv({
          flag: 1,
          isActive: 6
        }, $event))
      }, "近20场", 2)])])]), _createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_createElementVNode("span", _hoisted_26, "近" + _toDisplayString(historyStatistics.value.totalLegCnt) + "场", 1), _createElementVNode("span", _hoisted_27, _toDisplayString(historyStatistics.value.teamShortName), 1), _createElementVNode("span", _hoisted_28, _toDisplayString(historyStatistics.value.winGoalMatchCnt) + "胜 (" + _toDisplayString(historyStatistics.value.winProbability) + ")", 1), _createTextVNode(" | "), _createElementVNode("span", _hoisted_29, _toDisplayString(historyStatistics.value.drawMatchCnt) + "平 (" + _toDisplayString(historyStatistics.value.drawProbability) + ")", 1), _createTextVNode(" | "), _createElementVNode("span", _hoisted_30, _toDisplayString(historyStatistics.value.lossGoalMatchCnt) + "负 (" + _toDisplayString(historyStatistics.value.lossProbability) + ")", 1)]), _createElementVNode("table", _hoisted_31, [_hoisted_32, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(historyMatchList.value, (match, key) => {
        return _openBlock(), _createElementBlock("tr", {
          key: key
        }, [_createElementVNode("td", _hoisted_33, _toDisplayString(match.matchDate), 1), _createElementVNode("td", null, _toDisplayString(match.tournamentShortName), 1), _createElementVNode("td", _hoisted_34, [_createElementVNode("a", null, [_createElementVNode("div", _hoisted_35, [_createElementVNode("div", _hoisted_36, _toDisplayString(match.homeTeamShortName), 1), _createElementVNode("div", _hoisted_37, [_createElementVNode("p", _hoisted_38, _toDisplayString(match.fullCourtGoal), 1), _createElementVNode("p", _hoisted_39, "（半 " + _toDisplayString(match.halfTimeGoal) + "）", 1)]), _createElementVNode("div", _hoisted_40, _toDisplayString(match.awayTeamShortName), 1)])])])]);
      }), 128))])]), _createElementVNode("div", _hoisted_41, [_hoisted_42, _createTextVNode("比赛近况 "), _createElementVNode("div", _hoisted_43, [_createElementVNode("div", _hoisted_44, [_createElementVNode("div", {
        class: _normalizeClass(["u-check", {
          active: isActive7.value
        }]),
        onClick: _cache[6] || (_cache[6] = $event => clickDiv3({
          flag: 0,
          isActive: 7
        }, $event))
      }, [_createElementVNode("span", null, _toDisplayString(matchHead.value.homeTeamShortName), 1)], 2), _createElementVNode("div", {
        class: _normalizeClass(["u-check", {
          active: isActive8.value
        }]),
        onClick: _cache[7] || (_cache[7] = $event => clickDiv3({
          flag: 1,
          isActive: 8
        }, $event))
      }, _toDisplayString(matchHead.value.awayTeamShortName), 3)]), _createElementVNode("div", _hoisted_45, [_createElementVNode("div", {
        class: _normalizeClass(["u-check", {
          active: isActive9.value
        }]),
        onClick: _cache[8] || (_cache[8] = $event => clickDiv2({
          flag: 0,
          isActive: 9
        }, $event))
      }, _hoisted_47, 2), _createElementVNode("div", {
        class: _normalizeClass(["u-check", {
          active: isActive10.value
        }]),
        onClick: _cache[9] || (_cache[9] = $event => clickDiv2({
          flag: 1,
          isActive: 10
        }, $event))
      }, "相同赛制", 2)])]), _createElementVNode("div", _hoisted_48, [_createElementVNode("div", _hoisted_49, [_createElementVNode("div", {
        class: _normalizeClass(["u-check", {
          active: isActive11.value
        }]),
        onClick: _cache[10] || (_cache[10] = $event => clickDiv2({
          flag: 0,
          isActive: 11
        }, $event))
      }, "不区分主客场", 2), _createElementVNode("div", {
        class: _normalizeClass(["u-check", {
          active: isActive12.value
        }]),
        onClick: _cache[11] || (_cache[11] = $event => clickDiv2({
          flag: 1,
          isActive: 12
        }, $event))
      }, "相同主客场", 2)]), _createElementVNode("div", _hoisted_50, [_createElementVNode("div", {
        class: _normalizeClass(["u-check", {
          active: isActive13.value
        }]),
        onClick: _cache[12] || (_cache[12] = $event => clickDiv2({
          flag: 0,
          isActive: 13
        }, $event))
      }, "近10场", 2), _createElementVNode("div", {
        class: _normalizeClass(["u-check", {
          active: isActive14.value
        }]),
        onClick: _cache[13] || (_cache[13] = $event => clickDiv2({
          flag: 1,
          isActive: 14
        }, $event))
      }, "近20场", 2)])])]), _createElementVNode("div", _hoisted_51, [_createElementVNode("div", _hoisted_52, [_createElementVNode("span", _hoisted_53, "近" + _toDisplayString(teamStatistics.value.totalLegCnt) + "场", 1), _createElementVNode("span", _hoisted_54, _toDisplayString(teamStatistics.value.teamShortName), 1), _createElementVNode("span", _hoisted_55, _toDisplayString(teamStatistics.value.winGoalMatchCnt) + "胜 (" + _toDisplayString(teamStatistics.value.winProbability) + ")", 1), _createTextVNode(" | "), _createElementVNode("span", _hoisted_56, _toDisplayString(teamStatistics.value.drawMatchCnt) + "平 (" + _toDisplayString(teamStatistics.value.drawProbability) + ")", 1), _createTextVNode(" | "), _createElementVNode("span", _hoisted_57, _toDisplayString(teamStatistics.value.lossGoalMatchCnt) + "负 (" + _toDisplayString(teamStatistics.value.lossProbability) + ")", 1)]), _createElementVNode("table", _hoisted_58, [_hoisted_59, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(teamMatchList.value, (match, key) => {
        return _openBlock(), _createElementBlock("tr", {
          key: key
        }, [_createElementVNode("td", _hoisted_60, _toDisplayString(match.matchDate), 1), _createElementVNode("td", null, _toDisplayString(match.tournamentShortName), 1), _createElementVNode("td", _hoisted_61, [_createElementVNode("a", null, [_createElementVNode("div", _hoisted_62, [_createElementVNode("div", _hoisted_63, _toDisplayString(match.homeTeamShortName), 1), _createElementVNode("div", _hoisted_64, [_createElementVNode("p", _hoisted_65, _toDisplayString(match.fullCourtGoal), 1), _createElementVNode("p", _hoisted_66, "（半 " + _toDisplayString(match.halfTimeGoal) + "）", 1)]), _createElementVNode("div", _hoisted_67, _toDisplayString(match.awayTeamShortName), 1)])])])]);
      }), 128))])])], 64);
    };
  }
};